import { fromJS } from 'immutable';
import { get } from 'lodash';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  result: [],
  categories: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCHED_TOPICS: {
      const category_ids = get(
        action,
        ['payload', 'topics', 'result', 'categories'],
        [],
      );

      if (!category_ids.length) return state;

      return state
        .mergeIn(
          ['categories'],
          fromJS(action.payload.topics.entities.categories),
        )
        .set('result', category_ids || state.get('result'));
    }

    default:
      return state;
  }
};
